/* eslint-disable no-useless-concat */
/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Button from '@ingka/button';
import { selectSelectedTopic, selectContactPage } from 'Store/selectors';

import { useGetTopicQuery } from 'Services/api';
import { sendAnalyticEvent } from '../../utils/analytics';
import RecommendedLabel from '../recommendedLabel/RecommendedLabel.jsx';

// Button
import '@ingka/svg-icon/style.scss';
import '@ingka/button/style.scss';
import '@ingka/focus/style.scss';
import RichTextEditor from '../RichTextEditor/RichText.jsx';
import './SelfServiceOption.scss';
import StillNeedHelp from '../stillNeedHelp/StillNeedHelp.jsx';

const SelfServiceOption = ({ headline, content, buttonLink, buttonLabel, imgCMS }) => {
    const cardClass = () => (!imgCMS ? 'selfservice' : 'selfservice-with-image' + ' selfservice');

    const { data: pages } = useGetTopicQuery();

    const selectedTopic = useSelector(selectSelectedTopic);
    const selectedContactPage = useSelector(selectContactPage);
    const getSubTopic = () => {
        const topic = pages.topics.find(({ id }) => id === selectedTopic);
        const subtopic = topic?.topics.find(({ id }) => id === selectedContactPage);
        return subtopic?.topicHeadline;
    };

    const sendToAnalytic = () => {
        sendAnalyticEvent({
            action: getSubTopic(),
            category: `CSP-5-${buttonLabel}`,
            label: 'Recommended',
        });
        sendAnalyticEvent({ category: 'pageview', pagePath: buttonLink });
    };

    const handleOnClick = () => {
        if (getSubTopic() && buttonLabel) sendToAnalytic();
    };
    const recommendedValid = buttonLink && buttonLabel;
    const imageValid = imgCMS;

    return (
        <Fragment>
            <div className={cardClass()}>
                {imageValid && (
                    <div className="selfservice-with-image__picture" data-cy="selfservice-image">
                        <img src={imgCMS} alt="" data-testid="selfservice-img" />
                    </div>
                )}
                <div>
                    {recommendedValid && (
                        <>
                            <div className="selfservice__label" data-cy="recommended-label">
                                <RecommendedLabel />
                            </div>
                            {/* Description and title DESKTOP */}
                            <h2 className="selfservice__title" data-cy="selfservice-headline">
                                {headline}
                            </h2>
                            <div
                                className="selfservice__description"
                                data-cy="selfservice-description"
                            >
                                <RichTextEditor data={content} />
                            </div>

                            <Button
                                data-cy="button-selfService"
                                href={buttonLink}
                                onClick={handleOnClick}
                                className="selfservice__button"
                                data-testid="selfservice-button"
                                type="emphasised"
                            >
                                {buttonLabel}
                            </Button>
                        </>
                    )}
                </div>
            </div>
            <div className="separator" />
            {/* This component shows as a way to present the contact cards. */}
            <StillNeedHelp />
        </Fragment>
    );
};

export default SelfServiceOption;
